export function normalizeBlacklistResponse(data) {
  if (data == null) {
    return [];
  }
  if (Array.isArray(data)) {
    return data;
  }
  if (typeof data === 'string') {
    try {
      return normalizeBlacklistResponse(JSON.parse(data));
    } catch {
      return [];
    }
  }
  if (typeof data === 'object') {
    if (Array.isArray(data.content)) {
      return data.content;
    }
    if (Array.isArray(data.data)) {
      return data.data;
    }
    if (data.email != null || data.keycloakUserId != null) {
      return [data];
    }
  }
  return [];
}
